import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_STAFF_START, DELETE_STAFF_ERROR, DELETE_STAFF_SUCCESS, GET_STAFF_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/staff/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_STAFF_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_STAFF_ERROR, error });
  } finally {
    yield put({ type: GET_STAFF_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_staff() {
  yield takeLatest(DELETE_STAFF_START, del);
}

